import { css } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

export const dstSubmitCTA = css`
  background-color: ${cssTheme.palette.cta};
  color: ${cssTheme.palette.ctaContrast};
`;
